import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ListingsPage = lazy(() => import('../pages/listings/page'));
const OwnersPortalPage = lazy(() => import('../pages/owners-portal/page'));
const WhyListPage = lazy(() => import('../pages/why-list/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/listings',
    element: <ListingsPage />
  },
  {
    path: '/owners-portal',
    element: <OwnersPortalPage />
  },
  {
    path: '/why-list',
    element: <WhyListPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;